(function($){

	var docReady = function(){
		var $body = $('body');

		$('#siteSearchBtn').on('click', function() {
			$body.toggleClass('body--search-open');
			var search_position = $body.width() - $(this).offset().left - $(this).outerWidth();
			$('#siteSearchHolder').css('right',search_position+'px')
				.find('.search-field').focus();
		});

	};

    var universalSmoothScroll = function(){
        if ( location.hash.length && $( location.hash ).length ){
            window.scrollTo(0, 1);
            var position = $( location.hash ).offset().top - $('.site-header').outerHeight();
            
            $('html, body').animate({
                scrollTop: position
            }, 800);
        }
        
        $('a[href*="#"]').on('click', function(e){
            $target = $(e.target)
            if ($target.prop("tagName") !== 'A') {
                $target = $target.closest('a')
            }

            if ($target.attr('href').indexOf(window.location.origin) !== 0) {
                return;
            }
            e.preventDefault();
            
            $('html, body').stop().animate({
                scrollTop: 0
            }, 800);
            
        });

        $('.home__giving__scroll').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            var _this_location = $(this).attr('href');
            var _this_position = $( _this_location ).offset().top - $('.site-header').outerHeight();

            $('html, body').stop().animate({
                scrollTop: _this_position
            }, 800);
        });
    };

    var wordSlider = function( array ){
        var $wordSlider = $('[data-target="word-slider"]');
        var currentIndex = array.indexOf($wordSlider.html());
        var nextIndex = currentIndex + 1; 

        if (nextIndex >= array.length) {
            nextIndex = 0;
        }

        $wordSlider.css({'opacity': 0});            
        $wordSlider.on("transitionend webkitTransitionEnd oTransitionEnd", function(e){
            $wordSlider.empty();
            $wordSlider.append(array[nextIndex]);
            $wordSlider.css({'opacity': 1});
        });
    };


    var initWordSlider = function(){
        var SECOND_IN_MILLISECONDS = 1000;
        var wordSliderArray;

        //Feature is homepage only.
        if ($('body.home').length) {
            wordSliderArray = JSON.parse(MSWObject.wordSliderArray);

            //Something weird has to happen if there is no primary word in the headline. Log it.
            if( wordSliderArray.length == 0){
                console.log("Makespace Says: No Primary or Additional strings available in the homepage's headline. That really shouldn't happen. Check the home page editor.");
                return;
            }

            if( wordSliderArray.length > 1 ){
                window.setInterval( wordSlider, 3 * SECOND_IN_MILLISECONDS, wordSliderArray);     
            }
        }
    };

    var initMap = function() {
        if( !$( '#cd-map' ).length ){
            return;
        }

        $(window).on('load', function() {
            var map_container = document.getElementById( 'cd-map' );
            var uluru = new google.maps.LatLng(map_container.getAttribute('data-lat'), map_container.getAttribute('data-lng'));

            map = new google.maps.Map(map_container, {
              center: uluru,
              zoom: 13
            });

            bounds = new google.maps.LatLngBounds();

            // create marker
            var marker = new google.maps.Marker({
                position    : uluru,
                map         : map
            });

            google.maps.event.addDomListener(window, 'resize', function() {
                map.fitBounds( bounds );
                map.setCenter( uluru );
                map.setZoom( 13 );
            });
        });

        
    };

    var openGiveTodayForm = function(){
        if( $('[data-target="opensGiveTodayForm"]').length ) {
            var $giveToday = $('.give-today__form-wrapper');
            $('[data-target="opensGiveTodayForm"]').on('click', function(e){
                var _this_position = $giveToday.offset().top - $('.site-header').outerHeight();
                
                $giveToday.addClass('active');

                $('html, body').stop().animate({
                    scrollTop: _this_position
                }, 800);
            });

            if( window.location.href.indexOf( '#gf_' ) >= 0 ){
                $giveToday.addClass('active');
            }
        }
    };

    var addBreadcrumbs = function() {

        var $body = $('body');

        // Add Staging URL path if on Staging
        var url_origin = "";
        if (window.origin == "https://staging.mswhost.com") {
            var pathArray = window.location.pathname.split( '/' );
            url_origin = window.origin + "/" + pathArray[1];
        }

        // Add Breadcrumb to Staff and Board of Directors
        if ( $body.hasClass('post-type-archive-staff') || $body.hasClass('post-type-archive-board-directors') ) {
            var breadcrumbItem = '<li><a href="' + url_origin + '/about-us">About Us</a></li>';
            $('#breadcrumbs').find('li:first').after(breadcrumbItem);
        }

        // Add Breadcrumb to Our Impact
        if ( $body.hasClass('post-type-archive-our-impact') || $body.hasClass('single-our-impact') ) {
            var breadcrumbItem = '<li><a href="' + url_origin + '/how-we-help">How We Help</a></li>';
            $('#breadcrumbs').find('li:first').after(breadcrumbItem);
        }

    }


	$(document).ready(function(){
		docReady();
		universalSmoothScroll();
        initWordSlider();
        initMap();
        openGiveTodayForm();
        addBreadcrumbs();
	});

})(jQuery);